import i18n from '@signavio/i18n'

import { LegacyHint } from '@signavio/ui'
import { ComponentType, ReactNode } from 'react'

import types from '../../apiTypes'
import { useApi } from '../../api'
import { useUser } from '../../'
import { UserPreferences } from '../../../types'

type WithUserPreferencesProps = {
  userPreferences: UserPreferences
}

export default function withUserPreferences<T>(
  WrappedComponent: ComponentType<React.PropsWithChildren<T>>
) {
  function UserPreferences(
    props: ComponentType<React.PropsWithChildren<T>>
  ): ComponentType<WithUserPreferencesProps & T> | ReactNode {
    const user = useUser()

    const [fetchPreferences] = useApi(types.USER_PREFERENCE, {
      query: {
        id: user.id,
      },
    })

    if (!fetchPreferences.value || fetchPreferences.pending) {
      return null
    }

    if (fetchPreferences.rejected) {
      return (
        <LegacyHint danger>
          {i18n(
            'Could not load user preferences for the following reason: __reason__',
            {
              reason: fetchPreferences.reason,
            }
          )}
        </LegacyHint>
      )
    }

    return (
      <WrappedComponent
        userPreferences={fetchPreferences.value}
        {...(props as T)}
      />
    )
  }

  return UserPreferences
}
